"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypingDuration = exports.HostBubble = exports.mediaLoadingFallbackTimeout = exports.showAnimationDuration = exports.defaultTypeSpeed = void 0;
const react_1 = __importStar(require("react"));
const models_1 = require("../../models");
const BubbleContent_1 = require("./BubbleContent");
const TypingContent_1 = require("./TypingContent");
exports.defaultTypeSpeed = {
    long: 2000,
    medium: 1400,
    short: 600,
};
exports.showAnimationDuration = 400;
exports.mediaLoadingFallbackTimeout = 5000;
const HostBubble = ({ message, onTransitionEnd, onResize, skipAnimations, }) => {
    const [typing, setTyping] = (0, react_1.useState)(true);
    const isIframe = message &&
        typeof message !== "string" &&
        "type" in message &&
        [models_1.BubbleContentType.IFRAME, models_1.BubbleContentType.VIDEO].includes(message === null || message === void 0 ? void 0 : message.type);
    (0, react_1.useEffect)(() => {
        window.addEventListener("resize", onResize);
    }, []);
    const onTypingEnd = () => {
        setTyping(false);
        setTimeout(() => {
            onTransitionEnd();
        }, exports.showAnimationDuration);
    };
    return (react_1.default.createElement("div", { className: "flex mb-2 w-full lg:w-11/12 items-center" },
        react_1.default.createElement("div", { className: "flex relative z-10 items-start typebot-host-bubble " +
                (isIframe ? "w-full" : "") },
            react_1.default.createElement("div", { className: "flex items-center absolute px-4 py-2 rounded-lg bubble-typing z-10 ", style: {
                    width: typing ? "4rem" : "100%",
                    height: typing ? "2rem" : "100%",
                } }, typing ? react_1.default.createElement(TypingContent_1.TypingContent, null) : react_1.default.createElement(react_1.default.Fragment, null)),
            react_1.default.createElement(BubbleContent_1.BubbleContent, { message: message, skipAnimations: skipAnimations, onTypingEnd: onTypingEnd }))));
};
exports.HostBubble = HostBubble;
const getTypingDuration = (skipAnimations, customTypingSpeeds, message) => {
    const typeSpeeds = getBubbleTypeSpeeds(skipAnimations, customTypingSpeeds);
    if (!message)
        return 0;
    const messageContent = typeof message === "string" || !("plainText" in message)
        ? message.toString()
        : message.plainText;
    if (messageContent.length >= 120) {
        return typeSpeeds.long;
    }
    if (messageContent.length >= 60) {
        return typeSpeeds.medium;
    }
    return typeSpeeds.short;
};
exports.getTypingDuration = getTypingDuration;
const getBubbleTypeSpeeds = (skipAnimations, customTypingSpeeds) => {
    if (skipAnimations) {
        return {
            long: 0,
            medium: 0,
            short: 0,
        };
    }
    if (customTypingSpeeds) {
        return {
            long: customTypingSpeeds.long * 1000,
            medium: customTypingSpeeds.medium * 1000,
            short: customTypingSpeeds.short * 1000,
        };
    }
    return exports.defaultTypeSpeed;
};
//# sourceMappingURL=HostBubble.js.map